/**
 * Core Web Vitals を計測して dataLayer に流す（GTM 経由で GA4 へ送る）。
 *
 * 前提: assets/web-vitals.js（公式配布物・無改変）がこのファイルより先に読み込まれ、
 *       グローバル `webVitals` を公開していること。analytics-environment snippet が
 *       prod のときだけ async=false の動的 script を SDK → init の順に追加する。
 *
 * 構成の正本 / データの読み方:
 *   marketing-stacks リポジトリの .claude/rules/gtm-web-vitals.md
 */
(function () {
  'use strict';

  if (!window.haaProductionAnalyticsEnabled || !window.webVitals) return;

  var dl = (window.dataLayer = window.dataLayer || []);

  function send(metric) {
    // CLS は 0.05 のような小数。GA4 のパラメータは整数向けなので ×1000 して送り、
    // BigQuery 側で 1000 で割る。割り忘れると CLS だけ桁違いに悪く見えるので注意。
    var scale = metric.name === 'CLS' ? 1000 : 1;

    // 原因の手がかりになる要素セレクタ。指標ごとにフィールド名が異なる
    //   LCP: target / INP: interactionTarget / CLS: largestShiftTarget
    //   （FCP・TTFB にはこの手のセレクタが無いので空文字になる）
    var a = metric.attribution || {};
    var target = a.target || a.interactionTarget || a.largestShiftTarget || '';

    dl.push({
      event: 'web_vitals',
      metric_name: metric.name,
      metric_value: Math.round(metric.value * scale),
      metric_delta: Math.round(metric.delta * scale),
      // 同一ページビュー内で同じ指標が複数回報告される。集計時はこのIDで重複排除する
      metric_id: metric.id,
      metric_rating: metric.rating,
      // GA4 の文字列パラメータは100文字で切られるため、切る位置を自分で決めておく
      metric_target: String(target).slice(0, 100)
    });
  }

  // reportAllChanges は指定しない（既定 false）。
  // 公式が production では非推奨としているうえ、送信回数が増えて計測自体が重くなる。
  webVitals.onLCP(send);
  webVitals.onINP(send);
  webVitals.onCLS(send);
  webVitals.onFCP(send);
  webVitals.onTTFB(send);
})();
